module.exports = __webpack_public_path__ + "img/6.ceda3a02.png";